module.exports = __webpack_public_path__ + "media/aerial-farm-fullhd03.c6214332.mp4";